jQuery(document).ready(function($) {
    if ($('.testimonial__slider_mt--activation').length > 0) {

        var $slider = $('.testimonial__slider_mt--activation');

        var leftIcon = $('#icon-arrow-left').html();
        var rightIcon = $('#icon-arrow-right').html();

        var slideLoop = $slider.data('slideLoop') === 'false' ? false : true;
        var slideAutoplay = $slider.data('slideAutoplay') === 'true';
        var autoplayDuration = $slider.data('autoplayDuration') || 5000;
        var slideShowSpace = $slider.data('slideshow') || 0;
        var sliderPerView = $slider.data('slidesperview') || 1;
        var smallDesktop = $slider.data('samlldesktopview') || 1;
        var tabletShow = $slider.data('showTablet') || 1;
        var mobileShow = $slider.data('showMobile') || 1;

        // var paginationEnabled = $slider.data('testimonial_pagination') === 'true';
        // var navigationEnabled = $slider.data('testimonial_navigation') === 'true';

        var autoplay = slideAutoplay ? {
            delay: autoplayDuration,
            disableOnInteraction: false
        } : false;

        var sliderOptions = {
            loop: slideLoop,
            // nav: navigationEnabled,
            nav: true,
            navText: [leftIcon, rightIcon],
            // dots: paginationEnabled,
            dots: true,
            items: 1,
            autoplay: autoplay,
            autoplayTimeout: autoplayDuration,
            responsiveRefreshRate: 200,
            responsive: {
                0: {
                    items: mobileShow
                },
                750: {
                    items: tabletShow
                },
                992: {
                    items: smallDesktop
                },
                1200: {
                    items: sliderPerView
                }
            }
        };

        var owl = $slider.owlCarousel(sliderOptions);

        $('.owl-dot').click(function () {
            owl.trigger('to.owl.carousel', [$(this).index(), 300]);
        });

        $slider.find('.owl-item').each(function(i) {
            var thumbnail = $(this).find('.testimonial__images').html();
            var dot = ".owl-dot:eq(" + i + ")";
            $(dot).html(thumbnail);
        });

        // $slider.find('.owl-dots').prependTo($slider);

    } else {
        console.warn('Owl Carousel element not found.');
    }
});